"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlamesOfWarAbilityHandler = exports.FlamesOfWarActorAbilityFactory = exports.FlamesOfWarAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
class FlamesOfWarAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.FlamesOfWar;
        this.__typeName = "FlamesOfWar";
    }
}
exports.FlamesOfWarAbilityArgs = FlamesOfWarAbilityArgs;
let FlamesOfWarActorAbilityFactory = class FlamesOfWarActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("FlamesOfWar", "Self", 0);
    }
};
FlamesOfWarActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("FlamesOfWar")
], FlamesOfWarActorAbilityFactory);
exports.FlamesOfWarActorAbilityFactory = FlamesOfWarActorAbilityFactory;
let FlamesOfWarAbilityHandler = class FlamesOfWarAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            duration: Duration_1.Duration.Permanent,
            effect: new core_1.LinkedEventHandlerEffectArgs("Flames of War", "50% chance to burn attackers", false, container.registerEventHandlerScript(actorId, EventType_1.EventType.Attacked, Schedule_1.Schedule.Unlimited, "ApplyEffect_OnAttacked", {
                applyTo: "attacker",
                onHitOnly: true,
                effects: [
                    {
                        percentChance: 50,
                        duration: Duration_1.Duration.Turns(2),
                        effect: new core_1.BurningEffectArgs("Focus", 10),
                    }
                ]
            })),
            supernatural: true,
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
FlamesOfWarAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.FlamesOfWar)
], FlamesOfWarAbilityHandler);
exports.FlamesOfWarAbilityHandler = FlamesOfWarAbilityHandler;
